/* Cobra — seleção de variantes sobre a foto (variantes-overlay.liquid).
   Delegação no document (sobrevive aos re-renders do Dawn). Clique no chip marca o
   radio do seletor NATIVO (variant-selects) e dispara 'change' — preço/SKU/galeria
   seguem pela lógica nativa. Depois, sincroniza o estado visual dos chips. */
(function () {
  /* marca que o overlay esta ativo; o CSS so esconde o seletor nativo (mobile) quando
     esta classe existe — sem JS, o nativo continua visivel (fallback) */
  document.documentElement.classList.add('vov-js');

  /* variant-selects VIVO: apos cada troca o Dawn insere o seletor novo e mantem o
     velho no DOM por ~500ms (display:none, radios ainda marcados na selecao ANTIGA).
     Consultar o documento inteiro nessa janela le o no moribundo -> estado errado /
     intermitencia com toques rapidos. Aqui sempre miramos o primeiro nao-escondido. */
  function liveVS() {
    var todos = document.querySelectorAll('variant-selects');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].style.display !== 'none') return todos[i];
    }
    return null;
  }

  function radios() {
    var vs = liveVS();
    return vs ? Array.prototype.slice.call(vs.querySelectorAll('input[type="radio"]')) : [];
  }

  /* Faixa da garantia vitalícia (data-cobra-gar): fica ABAIXO dos botões, fora do
     #price- que o Dawn re-renderiza — então o some/aparece de "Com red dot" é por aqui.
     "Com" só existe na opção Red Dot, então basta um radio marcado com value "com". */
  function syncGarantia() {
    var faixas = document.querySelectorAll('[data-cobra-gar]');
    if (!faixas.length) return;
    var comRedDot = radios().some(function (r) {
      return r.checked && (r.value || '').toLowerCase() === 'com';
    });
    faixas.forEach(function (el) { el.hidden = comRedDot; });
  }

  /* Aviso de fabricacao sob encomenda (data-cobra-encomenda). A regra do projeto e uma
     so: variante com RASTREIO de estoque LIGADO = sob encomenda; o resto do catalogo nao
     e rastreado = pronta entrega. O Liquid ja imprime a lista de ids em data-ids, entao
     aqui e so casar com a variante selecionada. Mesmo motivo da garantia: o aviso fica
     ABAIXO dos botoes, fora do #price- que o Dawn re-renderiza. */
  function syncEncomenda() {
    var avisos = document.querySelectorAll('[data-cobra-encomenda]');
    if (!avisos.length) return;
    var input = document.querySelector('.product-variant-id');
    var id = input ? String(input.value || '') : '';
    avisos.forEach(function (el) {
      var ids = (el.getAttribute('data-ids') || '').split(',');
      el.hidden = !id || ids.indexOf(id) === -1;
    });
  }

  /* ---- Galeria no DESKTOP: setas vivas + contador certo (Cobra, 2026-08-27) ----------
     No desktop a lista de midias NAO rola: ela mostra so a que tem .is-active, e as outras
     ficam display:none (a troca e feita pela miniatura, via media-gallery.setActiveMedia).
     As setas nativas do Dawn, porem, so sabem ROLAR — entao no desktop elas nao faziam
     nada, e o contador nativo mostrava um total que nao era o das fotos exibidas.
     Aqui as setas passam a trocar a MIDIA ATIVA (clicando na miniatura correspondente, que
     e o caminho que o proprio tema ja usa) e o contador passa a contar as fotos que a
     galeria REALMENTE mostra — a filtragem por variante ja tirou o resto do DOM.
     ⚠️ So no desktop e so quando a lista nao rola. No MOBILE nada disso roda: la a lista
     rola de verdade e quem conta e a faixa .cobra-vov-nav (syncGaleria). */
  function ehDesktopSemRolagem(sc) {
    return window.matchMedia('(min-width: 750px)').matches &&
           !!sc.slider && sc.slider.scrollWidth <= sc.slider.clientWidth + 1;
  }

  function midiasDaGaleria(sc) {
    return Array.prototype.slice.call(sc.querySelectorAll('.product__media-item[data-media-id]'));
  }

  function indiceAtivo(itens) {
    for (var i = 0; i < itens.length; i++) {
      if (itens[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function syncGaleriaDesktop() {
    document.querySelectorAll('slider-component.vov-rail').forEach(function (sc) {
      if (!ehDesktopSemRolagem(sc)) return;
      var itens = midiasDaGaleria(sc);
      if (!itens.length) return;
      var i = indiceAtivo(itens);
      var cur = sc.querySelector('.slider-counter--current');
      var tot = sc.querySelector('.slider-counter--total');
      if (cur) cur.textContent = i + 1;
      if (tot) tot.textContent = itens.length;
      var prev = sc.querySelector('button[name="previous"]');
      var next = sc.querySelector('button[name="next"]');
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= itens.length - 1;
      var cont = sc.querySelector('.slider-counter');
      // uma foto so: contador e setas nao informam nada
      if (cont) cont.hidden = itens.length < 2;
      if (prev) prev.hidden = itens.length < 2;
      if (next) next.hidden = itens.length < 2;
    });
  }

  /* clique nas setas nativas, no desktop: troca a midia ativa em vez de rolar */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="previous"], button[name="next"]');
    if (!btn) return;
    var sc = btn.closest('slider-component.vov-rail');
    if (!sc || !ehDesktopSemRolagem(sc)) return;
    e.preventDefault();
    e.stopPropagation();
    var itens = midiasDaGaleria(sc);
    if (itens.length < 2) return;
    var i = indiceAtivo(itens);
    var alvo = btn.name === 'next' ? i + 1 : i - 1;
    if (alvo < 0 || alvo >= itens.length) return;
    var id = itens[alvo].getAttribute('data-media-id');
    var galeria = sc.closest('media-gallery');
    // chama o metodo DIRETO, nao o clique na miniatura: depois de uma troca de variante a
    // miniatura esta sem listener (ver ligaMiniaturas, abaixo) e o clique seria no vazio.
    if (galeria && galeria.setActiveMedia) galeria.setActiveMedia(id, false);
    setTimeout(syncGaleriaDesktop, 60);
  }, true);

  /* Miniaturas: o media-gallery.js liga o clique de CADA miniatura no connectedCallback,
     mas a troca de variante RE-RENDERIZA o interior da galeria (a lista de fotos muda com
     mao/cor) sem recriar o elemento <media-gallery> — as miniaturas novas nascem sem
     listener e param de trocar a foto. Bug antigo, e no desktop era o unico jeito de
     navegar. Aqui o clique e DELEGADO no document, entao sobrevive a qualquer re-render.
     Chamar setActiveMedia duas vezes (nativo + este) e inofensivo: e idempotente.
     Cobra, 2026-08-27. */
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest && e.target.closest('[data-target]');
    if (!alvo || !alvo.dataset || !alvo.dataset.target) return;
    var galeria = alvo.closest('media-gallery');
    if (!galeria || typeof galeria.setActiveMedia !== 'function') return;
    galeria.setActiveMedia(alvo.dataset.target, false);
    setTimeout(syncGaleriaDesktop, 60);
  });

  /* feedback de carregamento: fetch de variante leva 1-3s no 4G; sem indicacao,
     "ainda nao chegou" parece "nao mudou". Esmaece os chips ate o preco trocar. */
  var loadTimer = null;
  function setLoading(on) {
    document.querySelectorAll('[data-vov-root]').forEach(function (r) {
      r.classList.toggle('is-loading', on);
    });
    if (loadTimer) { clearTimeout(loadTimer); loadTimer = null; }
    if (on) loadTimer = setTimeout(function () { setLoading(false); }, 5000);
  }
  function watchPrice() {
    var box = document.querySelector('[id^="price-"]');
    if (box && 'MutationObserver' in window) {
      new MutationObserver(function () {
        setLoading(false); syncGarantia(); syncEncomenda(); syncGaleriaDesktop();
      }).observe(box, { childList: true, subtree: true });
    }
    /* o input da variante pode ser atualizado fora do #price-: ouvir a troca tambem */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"], select')) syncEncomenda();
    });
    syncGarantia(); /* estado inicial (default pode ser "Com" em algum produto) */
    syncEncomenda();
  }
  if (document.readyState !== 'loading') watchPrice();
  else document.addEventListener('DOMContentLoaded', watchPrice);

  /* setas + contador da FAIXA abaixo da foto: espelham os controles NATIVOS do slider.
     Nos limites a seta fica APAGADA (.is-off), não some — assim a faixa não "pula". O
     contador: total = fotos VISÍVEIS (o contador nativo do Dawn bugou em 6 com 5 fotos);
     atual = número do contador nativo (que o Dawn mantém certo mesmo com a barra oculta). */
  function syncGaleria() {
    document.querySelectorAll('slider-component.vov-rail').forEach(function (sc) {
      var prevBtn = sc.querySelector('.slider-buttons button[name="previous"]');
      var nextBtn = sc.querySelector('.slider-buttons button[name="next"]');
      var pa = sc.querySelector('[data-vov-nav="prev"]');
      var na = sc.querySelector('[data-vov-nav="next"]');
      if (pa) {
        var pd = !prevBtn || prevBtn.disabled;
        pa.disabled = pd;
        pa.classList.toggle('is-off', pd);
      }
      if (na) {
        var nd = !nextBtn || nextBtn.disabled;
        na.disabled = nd;
        na.classList.toggle('is-off', nd);
      }
      /* contador */
      var slides = sc.querySelectorAll('.product__media-item');
      var total = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].offsetParent !== null) total++;
      }
      var curEl = sc.querySelector('.slider-counter--current');
      var curBox = sc.querySelector('[data-vov-cont-cur]');
      var totBox = sc.querySelector('[data-vov-cont-tot]');
      if (curBox && curEl) curBox.textContent = (curEl.textContent || '1').trim();
      if (totBox && total) totBox.textContent = total;
    });
  }

  function watchGaleria() {
    document.querySelectorAll('slider-component.vov-rail').forEach(function (sc) {
      if (sc.dataset.vovWatch) return;
      sc.dataset.vovWatch = '1';
      if ('MutationObserver' in window) {
        var botoes = sc.querySelector('.slider-buttons');
        if (botoes) {
          new MutationObserver(syncGaleria).observe(botoes, {
            subtree: true, childList: true, characterData: true,
            attributes: true, attributeFilter: ['disabled']
          });
        }
        var ul = sc.querySelector('ul');
        if (ul) new MutationObserver(syncGaleria).observe(ul, { childList: true });
      }
      sc.addEventListener('scroll', syncGaleria, true); /* fallback p/ swipe */
      /* no desktop quem muda e a classe .is-active das midias, nao o scroll */
      if ('MutationObserver' in window) {
        new MutationObserver(syncGaleriaDesktop).observe(sc, {
          subtree: true, attributes: true, attributeFilter: ['class']
        });
      }
    });
    syncGaleria();
    syncGaleriaDesktop();
    window.addEventListener('resize', syncGaleriaDesktop);
  }
  if (document.readyState !== 'loading') watchGaleria();
  else document.addEventListener('DOMContentLoaded', watchGaleria);

  function sync() {
    document.querySelectorAll('[data-vov-root] [data-vov-name]').forEach(function (chip) {
      var name = chip.getAttribute('data-vov-name');
      var val = chip.getAttribute('data-vov-val');
      var on = radios().some(function (r) {
        return r.checked && r.value === val && r.name.indexOf(name + '-') === 0;
      });
      chip.classList.toggle('on', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* caixa de cor: nome selecionado + faixa do material seguem a cor marcada */
    document.querySelectorAll('.cobra-vov-cor').forEach(function (box) {
      var swOn = box.querySelector('.cobra-vov-cor__sw.on');
      if (!swOn) return;
      /* nome de EXIBIÇÃO (Preto -> Preto Tático); o valor real fica em data-vov-val */
      var nome = swOn.getAttribute('data-vov-disp') || swOn.getAttribute('data-vov-val');
      var cor = swOn.getAttribute('data-vov-cor');
      var nomeEl = box.querySelector('[data-vov-cor-nome]');
      if (nomeEl) nomeEl.textContent = nome;
      var band = box.querySelector('[data-vov-cor-band]');
      if (band) {
        band.className = 'cobra-vov-cor__band cobra-vov__sw--' + cor;
        var bt = band.querySelector('[data-vov-cor-bandtxt]');
        if (bt) bt.textContent = nome + ' · Kydex';
      }
      /* texto por cor: Carbono (acabamento diferente) tem texto próprio; senão o padrão */
      var txtEl = box.querySelector('[data-vov-cor-txt]');
      if (txtEl) {
        var espTxt = txtEl.getAttribute('data-txt-' + cor) || '';
        var padTxt = txtEl.getAttribute('data-txt-default') || '';
        txtEl.textContent = espTxt.trim() ? espTxt : padTxt;
      }
    });
    syncGarantia();
  }

  /* aplica de fato a variante (marca o radio nativo + dispara change) */
  function aplicar(alvo) {
    alvo.checked = true;
    alvo.dispatchEvent(new Event('change', { bubbles: true }));
    setLoading(true);
    sync();
  }

  /* popups de confirmação (red dot / canhoto).
     Move p/ o <body>: são position:fixed e um ancestral com transform/animação (reveal
     do Dawn) confinaria o fixed. Assim funcionam em tela cheia no mobile E no desktop. */
  (function moverPopups() {
    document.querySelectorAll('.cobra-pop').forEach(function (p) {
      if (p.parentNode !== document.body) document.body.appendChild(p);
    });
  })();

  /* qual popup uma opção nativa exige (Com red dot / Canhoto) — espelha o data-vov-confirm
     dos chips, mas p/ o seletor NATIVO (usado no desktop) */
  function tipoConfirm(name, val) {
    var n = (name || '').toLowerCase(), v = (val || '').toLowerCase();
    if (n.indexOf('red dot') !== -1 && v === 'com') return 'reddot';
    if ((n.indexOf('mao') !== -1 || n.indexOf('mão') !== -1) && v === 'canhoto') return 'canhoto';
    return null;
  }

  /* DESKTOP: valor CONFIRMADO por grupo de opção (name -> value). Necessário porque, ao
     clicar no <label>, o navegador sintetiza um clique no <input> com o radio JÁ marcado
     (checked=true) — por isso !checked NUNCA era verdadeiro e o popup não abria no
     desktop. Comparamos com este mapa p/ saber se a opção realmente MUDOU. Mantido em dia
     no 'change' e ao confirmar (OK). */
  var confirmadoPorGrupo = {};
  function snapshotConfirmado() {
    radios().forEach(function (r) { if (r.checked) confirmadoPorGrupo[r.name] = r.value; });
  }
  snapshotConfirmado();

  var pendente = null;
  function abrirPopup(tipo) {
    var pop = document.querySelector('.cobra-pop[data-vov-pop="' + tipo + '"]');
    if (!pop) return false;
    pop.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }
  function fecharPopups() {
    document.querySelectorAll('.cobra-pop.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    /* gatilho explícito de popup informativo (ex.: selo de garantia) — só abre, sem
       variante pendente; fecha pelos data-vov-pop-cancel/ESC de sempre */
    var abrirEl = e.target.closest('[data-vov-pop-abrir]');
    if (abrirEl) {
      abrirPopup(abrirEl.getAttribute('data-vov-pop-abrir'));
      return;
    }
    /* popup: confirmar aplica a variante pendente */
    if (e.target.closest('[data-vov-pop-ok]')) {
      if (pendente) {
        aplicar(pendente);
        confirmadoPorGrupo[pendente.name] = pendente.value; /* agora confirmado */
        pendente = null;
      }
      fecharPopups();
      return;
    }
    /* popup: voltar/scrim cancela (não muda nada) */
    if (e.target.closest('[data-vov-pop-cancel]')) {
      pendente = null;
      fecharPopups();
      return;
    }

    /* setas laterais: acionam os botoes nativos do slider (respeitam disabled/contador) */
    var nav = e.target.closest('[data-vov-nav]');
    if (nav) {
      var sc = nav.closest('slider-component');
      if (!sc) return;
      var sel = nav.getAttribute('data-vov-nav') === 'prev' ? 'button[name="previous"]' : 'button[name="next"]';
      var btn = sc.querySelector(sel);
      if (btn && !btn.disabled) btn.click();
      return;
    }

    var chip = e.target.closest('[data-vov-root] [data-vov-name]');
    if (chip) {
      var name = chip.getAttribute('data-vov-name');
      var val = chip.getAttribute('data-vov-val');
      var alvo = radios().find(function (r) {
        return r.value === val && r.name.indexOf(name + '-') === 0;
      });
      if (!alvo || alvo.checked) return;
      /* opções que exigem confirmação (Com red dot / Canhoto): abre o popup e só aplica no OK */
      var confirmar = chip.getAttribute('data-vov-confirm');
      if (confirmar && abrirPopup(confirmar)) { pendente = alvo; return; }
      aplicar(alvo);
      return;
    }

    /* DESKTOP: o cliente usa o seletor NATIVO (radios/pills). Ao clicar no <label>, o
       navegador sintetiza um clique no <input> com o radio JÁ marcado (checked=true) —
       por isso !checked nunca era verdadeiro e o popup não abria no desktop (bug). Aqui
       comparamos com o valor confirmado do grupo p/ detectar a MUDANÇA e segurar. */
    var nat = e.target.closest('variant-selects input[type="radio"]');
    if (nat) {
      var conf = tipoConfirm(nat.name, nat.value);
      if (conf && confirmadoPorGrupo[nat.name] !== nat.value && abrirPopup(conf)) {
        e.preventDefault();   // reverte a ativação do radio até confirmar
        pendente = nat;
        return;
      }
      confirmadoPorGrupo[nat.name] = nat.value; /* opção sem confirmação / já confirmada */
    }
  });

  /* ESC fecha o popup (cancela) */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('.cobra-pop.is-open')) {
      pendente = null;
      fecharPopups();
    }
  });

  /* mantém os chips em dia quando a troca vem do seletor nativo (abaixo da galeria) */
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('variant-selects input, variant-selects select')) {
      snapshotConfirmado();
      window.requestAnimationFrame(sync);
    }
  });
})();
